import { UseControllerProps } from 'react-hook-form';

export const NATIONAL_CODE_RULE: UseControllerProps['rules'] = {
  pattern: {
    value: /^[0-9]{10}$/,
    message: 'کد ملی نامعتبر است',
  },
};
